export default __webpack_public_path__ + "static/showcaseWebsitesMobile-79458b0051fff595ed509165b282105f.mp4";